Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useStyles = void 0;
var _reactNative = require("react-native-web");
var _styles = require("../../../../styles");
var useStyles = exports.useStyles = function useStyles(_ref) {
  var sharedStyles = _ref.sharedStyles;
  var paragraph = sharedStyles.paragraph,
    fontSemiBold = sharedStyles.fontSemiBold,
    focused = sharedStyles.focused;
  var link = Object.assign({}, fontSemiBold, {
    fontSize: paragraph.fontSize,
    textDecorationLine: 'underline',
    color: paragraph.color
  });
  var link_focused = Object.assign({}, focused, {
    outlineOffset: (0, _styles.getREM)(0.25),
    borderRadius: (0, _styles.getREM)(0.25)
  });
  var styles = _reactNative.StyleSheet.create({
    link: link,
    link_focused: link_focused
  });
  return {
    styles: styles
  };
};